import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = {
  key: 1,
  class: "playtable"
}
const _hoisted_3 = { class: "winner-name" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "ganó la partida", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_player_picture = _resolveComponent("player-picture")!
  const _component_board = _resolveComponent("board")!
  const _component_player_area = _resolveComponent("player-area")!

  return (!_ctx.assetsLoaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Cargando..."))
    : (_ctx.gameState)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.winner !== null)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["winner", `winner-${_ctx.winner.id}`])
              }, [
                _createVNode(_component_player_picture, { player: _ctx.winner }, null, 8, ["player"]),
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.winner.name), 1),
                _hoisted_4
              ], 2))
            : _createCommentVNode("", true),
          _createVNode(_component_board),
          (_ctx.playerIds.length >= 1)
            ? (_openBlock(), _createBlock(_component_player_area, {
                key: 1,
                "player-id": _ctx.playerIds[0],
                position: "top-left"
              }, null, 8, ["player-id"]))
            : _createCommentVNode("", true),
          (_ctx.playerIds.length >= 2)
            ? (_openBlock(), _createBlock(_component_player_area, {
                key: 2,
                "player-id": _ctx.playerIds[1],
                position: "bottom-left"
              }, null, 8, ["player-id"]))
            : _createCommentVNode("", true),
          (_ctx.playerIds.length >= 4)
            ? (_openBlock(), _createBlock(_component_player_area, {
                key: 3,
                "player-id": _ctx.playerIds[3],
                position: "top-right"
              }, null, 8, ["player-id"]))
            : _createCommentVNode("", true),
          (_ctx.playerIds.length >= 3)
            ? (_openBlock(), _createBlock(_component_player_area, {
                key: 4,
                "player-id": _ctx.playerIds[2],
                position: "bottom-right"
              }, null, 8, ["player-id"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
}